/**
 * Checks if a given string is undefined, null, empty, or consists only of white-space characters.
 * @param text: the string to check
 */
export function isNullOrWhiteSpace(text: string | null | undefined): boolean {
    return !text || text.trim().length == 0;
}
